import { NavLink, useLocation } from 'react-router';
import { Menu } from 'lucide-react';
import { GROUP_ICONS, GROUP_ORDER, modulesFor } from '../config/modules';
import { useAuth } from '../auth/context';

/** Phone tab bar: one tab per nav group (first page in the group) plus More (opens the sidebar). */
export function TabBar({ onMore }: { onMore: () => void }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const mods = modulesFor(user?.role);
  const groups = GROUP_ORDER.map((g) => ({ g, items: mods.filter((m) => m.group === g) })).filter(
    (x) => x.items.length,
  );
  return (
    <nav className="tabbar" aria-label="Sections">
      {groups.map(({ g, items }) => {
        const Icon = GROUP_ICONS[g];
        const active = items.some((m) => pathname.startsWith(m.path));
        return (
          <NavLink
            key={g}
            to={items[0]!.path}
            className={active ? 'active' : undefined}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={22} strokeWidth={1.7} />
            <span>{g}</span>
          </NavLink>
        );
      })}
      <button type="button" onClick={onMore}>
        <Menu size={22} strokeWidth={1.7} />
        <span>More</span>
      </button>
    </nav>
  );
}
